import React, { useState } from "react";
import { Lightbox } from "../components/Lightbox";

function Default({ pictures }) {
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setViewerIsOpen(false);
  };

  const photosForGallery = pictures.map((image) => ({
    src: image.medium[0],
    width: image.medium[1],
    height: image.medium[2],
  }));

  const lightboxImages = pictures.map((image) => image.lightboxbig[0]);

  return (
    <>
      <div id="gallery-ttb">
        {viewerIsOpen && (
          <Lightbox
            images={lightboxImages}
            currentImageIndex={currentImage}
            onClose={closeLightbox}
          />
        )}
        <div className="gallery-grid">
          {photosForGallery.map((image, index) => (
            <button
              className="gallery-grid__item"
              key={image.src}
              type="button"
              onClick={() => openLightbox(index)}
            >
              <img
                src={image.src}
                alt=""
                width={image.width}
                height={image.height}
                loading="lazy"
              />
            </button>
          ))}
        </div>
      </div>
    </>
  );
}

export const Gallery = React.memo(Default);
